
import { ApiService } from '..';

export const AppointmentService = {
    get(kamEmail) {
        return ApiService.get('appointments', kamEmail, false);
    },

    getBookedAppointments() {
        return ApiService.get('getBookedAppointments');
    },

    book(data) {
        return ApiService.postBase(data);
    },

    cancel(data) {
        return ApiService.postBase(data);
    },

    block(data) {
        return ApiService.postBase(data);
    },
};